var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"breadcrumb"},_vm._l((_vm.menuItems),function(item,index){return _c('span',{key:item},[_vm._v(_vm._s(item)+" "),(index < _vm.menuItems.length - 1)?_c('i',{staticClass:"fa fa-angle-right"}):_vm._e()])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }